import React from 'react';
import PropTypes from 'prop-types';

import { FormatPrice } from 'utils/format';

import { Icon, Flexer } from '@ontruck/orc';

const ShipperPriceCell = ({ totalPrice, currency, ...props }) => {
  return (
    <Flexer.Parent alignItems="center" {...props}>
      <Flexer.Child mRight="XS">
        <Icon glyph="factory" size="1.6rem" color="grey500" />
      </Flexer.Child>
      <Flexer.Child>
        <FormatPrice currency={currency} value={totalPrice} />
      </Flexer.Child>
    </Flexer.Parent>
  );
};

ShipperPriceCell.propTypes = {
  totalPrice: PropTypes.number,
  currency: PropTypes.string,
};

export default ShipperPriceCell;
